import { WalletResponseDto } from 'src/generated-sources/openapi/wallet-service/wallet';

export interface Wallet extends WalletResponseDto {}

export function createEmptyWallet(): Wallet {
  return {
    id: '',
    name: '',
    favorite: false,
    planId: '',
    clientId: '',
    type: 'PERSON',
    quantityRegistries: 0,
  };
}
